
import FieldNames from "../defaults/FieldNames.json";

// Sort by initiation date then Action ID
export function SortFundingRowsForExport(actions) {
  if (actions?.length > 0) {
    try {
      actions.sort((a,b) => { 
        let firstItem = new Date(a[FieldNames.featureFields.initiationDate]).toISOString();
        let secondItem = new Date(b[FieldNames.featureFields.initiationDate]).toISOString();

        if(isNaN(firstItem)){
          firstItem = "";
        }
        if(isNaN(secondItem)){
          secondItem = "";
        }

        if(secondItem === firstItem)
        {
          firstItem = a[FieldNames.featureFields.id];
          secondItem = b[FieldNames.featureFields.id];
        }

        return secondItem - firstItem;
      });
      return actions
    } catch (error) {
      return actions;
    }
  } else {
    return actions;
  }
}
